import { getRealmFromConfig } from '@app/App';
import { getPartner } from '@app/api/partners.api';
import { Breadcrumb } from '@app/components/common/Breadcrumb/Breadcrumb';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { ToolsTable } from '@app/components/tables/BasicTable/ToolsTable';
import { Card, TablesWrapper } from '@app/components/tables/Tables/Tables.styles';
import { PartnerModel } from '@app/domain/PartnerModel';
import { readConfigurationName } from '@app/services/localStorage.service';
import { useOidcAccessToken } from '@axa-fr/react-oidc';
import React, { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

const ToolsPage: React.FC = () => {
  const { partnerID } = useParams();
  const { accessToken } = useOidcAccessToken(readConfigurationName());
  const realm = getRealmFromConfig(readConfigurationName());
  const [partner, setPartner] = useState<PartnerModel | null>(null);
  const fetchPartner = useCallback(() => {
    if (!partnerID) return;
    const headers = {
      'ChatBD-Realm': realm,
      'ChatBD-Client-ID': 'chatbd-dashboard',
      Authorization: `Bearer ${accessToken}`,
    };
    getPartner(partnerID, headers).then((partner) => {
      setPartner(partner);
    });
  }, [accessToken, partnerID, realm]);

  useEffect(() => {
    fetchPartner();
  }, [fetchPartner]);

  if (!partnerID) {
    return null;
  }

  const desktopLayout = (
    <>
      <TablesWrapper>
        <Card id="tools-table" title="Tools Management" padding="1.25rem 1.25rem 0">
          <ToolsTable partnerID={partnerID} />
        </Card>
      </TablesWrapper>
    </>
  );

  return (
    <>
      <Breadcrumb>
        <Link to="/chats">Chats</Link>
        <div>&nbsp;/&nbsp;</div>
        <Link to={`/chat/${partnerID}`}>{partner?.name}</Link>
      </Breadcrumb>
      <PageTitle>Tools Management</PageTitle>
      {desktopLayout}
    </>
  );
};

export default ToolsPage;
